








import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import ProgressHeader from './ProgressHeader.vue'

const namespace = 'progress';

@Component({
    components: { ProgressHeader }
})
export default class ProgressComponents extends Vue {
    @Getter('getProgressStatus', { namespace }) getProgressStatus: any;

    
};
